module.exports = __webpack_public_path__ + "static/media/EMS-off.f8fc00fe.svg";